import { render, staticRenderFns } from "./TerminologyForm.vue?vue&type=template&id=ca1465b4"
import script from "./TerminologyForm.vue?vue&type=script&lang=js"
export * from "./TerminologyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports